// removed by extract-text-webpack-plugin
module.exports = {"Container":"dashboard__Container__1ao02","BreadCrumbs":"dashboard__BreadCrumbs__1kD6m","Main":"dashboard__Main__2Rz-y","SidePanel":"dashboard__SidePanel__1mj7X","Tabs":"dashboard__Tabs__20m5c","Content":"dashboard__Content__hRBVo","MainContent":"dashboard__MainContent__2epMH","Trash":"dashboard__Trash__1lnc5","CreateContainer":"dashboard__CreateContainer__3FhT6","CreateForParticipant":"dashboard__CreateForParticipant__hIMQM"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Dashboard/dashboard.css
// module id = 1268
// module chunks = 2